import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

export const apiAddManualFlight = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'addManualFlightEntryDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.post(serviceURL, {
    carrierCode: payload.carrierCode,
    conveyanceReference: payload.conveyance,
    destination: payload.destination,
    origin: payload.origin,
    validFrom: payload.validFrom,
    validTo: payload.validTo,
    monday: payload.monday,
    tuesday: payload.tuesday,
    wednesday: payload.wednesday,
    thursday: payload.thursday,
    friday: payload.friday,
    saturday: payload.saturday,
    sunday: payload.sunday,
  });
};

export const apiEditManualFlight = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'editFlightDefault',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      flightId: payload.flightId,
    },
  });
  return axios.put(serviceURL, {
    carrierCode: payload.carrierCode,
    conveyanceReference: payload.conveyance,
    destination: payload.destination,
    origin: payload.origin,
    validFrom: payload.validFrom,
    validTo: payload.validTo,
    monday: payload.monday,
    tuesday: payload.tuesday,
    wednesday: payload.wednesday,
    thursday: payload.thursday,
    friday: payload.friday,
    saturday: payload.saturday,
    sunday: payload.sunday,
  });
};
